export const ApplyStyles = ({ stylesArray }) => {
  document.head.insertAdjacentHTML(
    "beforeend",
    `<style type="text/css">${stylesArray.join(" ")}</style>`
  );
};
